module.exports = __webpack_public_path__ + "static/media/sy.2505dfa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sy.svg
// module id = 257
// module chunks = 0